import React from "react";
import { FaUsers, FaPuzzlePiece, FaGlobeAmericas, FaHeartbeat } from "react-icons/fa";
import "../style/AboutSection.css";
import about1 from "../images/about1.png";
import about2 from "../images/about2.png";
import about3 from "../images/about3.jpg";

const stats = [
  { value: "Launcher", label: "download e libreria" },
  { value: "Store", label: "acquisti e giochi gratis" },
  { value: "Playtest", label: "giochi Kyros in sviluppo" }
];

const highlights = [
  {
    title: "Partiamo dai nostri giochi",
    description: "Il sito serve a mostrare cosa puoi giocare, comprare o seguire tra i titoli Kyros.",
    image: about1,
    tag: "Kyros"
  },
  {
    title: "Zombie Crushers è il primo gioco da provare",
    description: "È gratis, si installa dal launcher e ha una classifica pubblica.",
    image: about3,
    tag: "Disponibile"
  },
  {
    title: "Ghost Hunter resta in sviluppo",
    description: "Lo mostriamo senza venderlo come prodotto finito. Quando sarà pronto, cambieremo lo stato.",
    image: about2,
    tag: "Playtest"
  }
];

const values = [
  {
    icon: FaUsers,
    title: "Chiarezza",
    copy: "Chi apre una pagina deve capire subito se può scaricare, comprare o solo seguire lo sviluppo."
  },
  {
    icon: FaPuzzlePiece,
    title: "Pochi giochi, spiegati bene",
    copy: "Preferiamo poche schede curate a un catalogo pieno di titoli senza stato chiaro."
  },
  {
    icon: FaHeartbeat,
    title: "Supporto leggibile",
    copy: "Account, launcher, acquisto e rimborso devono essere facili da trovare."
  },
  {
    icon: FaGlobeAmericas,
    title: "Stati onesti",
    copy: "Disponibile, in vendita o in sviluppo: lo diciamo senza giri di parole."
  }
];

const timeline = [
  {
    year: "2024",
    title: "Prime prove",
    body: "Kyros nasce da prototipi di giochi Windows e dal bisogno di distribuirli senza dipendere da pagine sparse."
  },
  {
    year: "2025",
    title: "Zombie Crushers",
    body: "Zombie Crushers diventa il primo titolo da provare davvero: launcher, account e classifica iniziano a lavorare insieme."
  },
  {
    year: "2026",
    title: "Store e account",
    body: "Lo Store collega schede prodotto, licenze e libreria Kyros. WarFront è il primo test importante di questo percorso."
  }
];

export default function AboutSection() {
  return (
    <section className="about-section">
      <div className="about-section__inner">
        <header className="about-hero">
          <span className="about-hero__eyebrow">Chi siamo</span>
          <h1>Kyros produce videogame per Windows con Store e launcher propri</h1>
          <p>
            Stiamo mettendo nello stesso posto i nostri giochi per Windows, lo Store e il launcher.
            Ogni titolo ha uno stato preciso: disponibile, in vendita o ancora in sviluppo.
          </p>
          <div className="about-hero__stats">
            {stats.map(item => (
              <article key={item.label}>
                <span>{item.value}</span>
                <small>{item.label}</small>
              </article>
            ))}
          </div>
        </header>

        <section className="about-highlights" aria-label="Progetti Kyros">
          <div className="about-highlights__grid">
            {highlights.map(card => (
              <article key={card.title} className="about-highlight-card">
                <span className="about-highlight-card__tag">{card.tag}</span>
                <div className="about-highlight-card__media">
                  <img src={card.image} alt={card.title} loading="lazy" />
                </div>
                <div className="about-highlight-card__body">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="about-values" aria-label="Cosa conta per Kyros">
          <h2>Cosa conta per noi</h2>
          <div className="about-values__grid">
            {values.map(value => {
              const Icon = value.icon;
              return (
                <article key={value.title} className="about-value-card">
                  <div className="about-value-card__icon">
                    <Icon />
                  </div>
                  <h3>{value.title}</h3>
                  <p>{value.copy}</p>
                </article>
              );
            })}
          </div>
        </section>

        <section className="about-timeline" aria-label="Timeline Kyros Games">
          <div className="about-timeline__header">
            <span className="about-hero__eyebrow">Timeline</span>
            <h2>Come si sta formando Kyros</h2>
          </div>
          <div className="about-timeline__list">
            {timeline.map(item => (
              <article key={item.year} className="about-timeline-card">
                <span>{item.year}</span>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="about-cta">
          <div>
            <h2>Vuoi seguire i giochi Kyros?</h2>
            <p>Parti dal catalogo, entra nello Store o raggiungici su Discord per aggiornamenti e playtest.</p>
          </div>
          <a href="/games">Vedi i giochi</a>
        </section>
      </div>
    </section>
  );
}
